import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Actions_Wind from "~/Actions_Wind";
import Actions_Wind_V2 from "~/Actions_Wind_V2";
import permission from "~/skills/permission";
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TablePagination, Link, Grid, makeStyles } from "@material-ui/core";
import ProgressTrackingDialog from "./dialogs/ProgressTrackingDialog";
import ProgressTrackingViewDialog from "./dialogs/ProgressTrackingViewDialog";
import ProgressTrackingEditDialog from "./dialogs/ProgressTrackingEditDialog";

const useStyles = makeStyles((theme) => ({
    searchButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    addButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    editButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    viewButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    deleteButton: {
        backgroundColor: "#999",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#777",
        },
    },
    downloadButton: {
        backgroundColor: "#74d6d4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#0ABAB5",
        },
    },
    headerRow: {
        backgroundColor: "#f7f7f7",
    },
    oddRow: {
        backgroundColor: "#E6F7FB",
    },
}));

function Page_PPTrackSheet(props) {
    const { getProgressTrackingSheetDocuments } = props;
    const classes = useStyles();
    const [search, setSearch] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const addBtnRef = useRef(null);

    const handleSearch = async () => {
        try {
            const body = {
                keyword: search,
                page_index: page + 1,
                page_size: rowsPerPage,
                windcontract_id: Actions_Wind.wind_id(),
            };

            const result = await getProgressTrackingSheetDocuments(body);

            if (result?.data?.data) {
                const docs = result.data.data.map((item, idx) => ({
                    id: item.id,
                    serial: page * rowsPerPage + idx + 1,
                    report_date: item.report_date || "-",
                    last_updated_date: item.last_updated_date || "-",
                    submitted_date: item.submitted_date || "-",
                    status: item.status?.description || "-",
                    status_code: item.status?.code || 0,
                }));
                setRows(docs);
                setTotalCount(result.data.pagination_info.total || 0);
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };

    useEffect(() => {
        handleSearch();
    }, [page, rowsPerPage]);

    const handleAdd = async () => {
        setOpenDialog(true);
    };

    const handleSave = async ({ status, data, sheetId }) => {
        try {
            const payload = {
                windcontract_id: Actions_Wind.wind_id(),
                sheet_id: sheetId,
                status: status ?? 0,
                data: data || [],
            };
            // console.log("送出 payload:", payload);
            await Actions_Wind_V2.createProgressTrackingSheetDocument(payload);
            await handleSearch();
        } catch (e) {
            console.error("新增及更新進度表單失敗", e);
        } finally {
            setTimeout(() => {
                setOpenDialog(false);
                setEditDialogOpen(false);
                addBtnRef.current?.focus();
            }, 0);
        }
    };

    const handleView = (id) => {
        setSelectedId(id);
        setViewDialogOpen(true);
    };

    const handleEdit = (id) => {
        setSelectedId(id);
        setEditDialogOpen(true);
    };

    const handleDelete = (id) => {
        setSelectedId(id);
        setDeleteConfirmOpen(true);
    };

    const handleDownload = async (sheetId) => {
        try {
            // 呼叫後端產生下載連結
            const result = await Actions_Wind_V2.getProgressTrackingSheetDocxFile({
                sheet_id: sheetId
            });

            const fileUrl =
                result?.data?.file_url ||
                result?.file_url; // 兼容 actions 回傳格式

            if (!fileUrl) {
                alert("無法取得下載連結");
                return;
            }

            // 建立隱藏下載連結並觸發下載
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "");

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error("下載失敗:", err);
            alert("下載失敗，請稍後再試");
        }
    };



    const confirmDelete = async () => {
        try {
            const success = await Actions_Wind_V2.deleteProgressTrackingSheetDocument(selectedId);
            if (success) {
                await handleSearch();
            } else {
                alert("刪除失敗");
            }
        } catch (err) {
            console.error("刪除失敗:", err);
        } finally {
            setDeleteConfirmOpen(false);
            setSelectedId(null);
        }
    };

    // 分頁控制
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box
            p={3}
            display="flex"
            flexDirection="column"
            style={{
                overflowY: "auto",
            }}
        >
            <Typography
                variant="h6"
                gutterBottom
                style={{ fontWeight: "bold", textAlign: "left", marginRight: "auto" }}
            >
                各工程進度
            </Typography>

            {/* 搜尋 */}
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 16 }}>
                <Grid item>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="請輸入關鍵字"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        className={classes.searchButton}
                        onClick={() => {
                            setPage(0); // 搜尋時重設 page
                            handleSearch();
                        }}
                    >
                        查詢
                    </Button>
                </Grid>
            </Grid>

            {/* 新增 */}
            <Box mb={2} display="flex" justifyContent="flex-start">
                <Button
                    ref={addBtnRef}
                    className={classes.addButton}
                    variant="contained"
                    onClick={handleAdd}
                >
                    + 新增一筆
                </Button>
            </Box>

            {/* 表格 */}
            <TableContainer component={Paper} style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <Table>
                    <TableHead>
                        <TableRow className={classes.headerRow}>
                            <TableCell>序號</TableCell>
                            <TableCell>報表日期</TableCell>
                            <TableCell>上次更新時間</TableCell>
                            <TableCell>送件時間</TableCell>
                            <TableCell>狀態</TableCell>
                            <TableCell style={{ textAlign: "center" }}>功能</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, idx) => (
                            <TableRow
                                key={row.id}
                                className={idx % 2 === 0 ? classes.oddRow : ""}
                            >
                                <TableCell>{row.serial}</TableCell>
                                <TableCell>{row.report_date}</TableCell>
                                <TableCell>{row.last_updated_date}</TableCell>
                                <TableCell>{row.submitted_date}</TableCell>
                                <TableCell>{row.status}</TableCell>
                                <TableCell>
                                    <Box display="flex" gridGap={8}>
                                        <Button size="small" className={classes.viewButton} onClick={() => handleView(row.id)}>
                                            檢視
                                        </Button>
                                        {
                                            !(row.status_code >= 2) && (
                                                <Button size="small" className={classes.editButton} onClick={() => handleEdit(row.id)} disabled={row.status_code >= 2}>
                                                    編輯
                                                </Button>
                                            )
                                        }
                                        {
                                            !(row.status_code >= 2) && (
                                                <Button size="small" className={classes.deleteButton} onClick={() => handleDelete(row.id)} disabled={row.status_code >= 2} >
                                                    刪除
                                                </Button>
                                            )
                                        }
                                        <Button size="small" className={classes.downloadButton} onClick={() => handleDownload(row.id)}>
                                            下載
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* 分頁 */}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage="每頁筆數"
                    labelDisplayedRows={({ from, to, count }) =>
                        `第 ${from}-${to} 筆，共 ${count} 筆`
                    }
                />
            </TableContainer>

            {/* 下載連結 */}
            <Grid container justify="flex-start" style={{ marginTop: 16 }}>
                <Grid item>
                    <Link
                        href="/static/attach_pp_track_template_file.docx"
                        underline="always"
                        download="工作進度追蹤報表格式.docx"
                    >
                        工作進度追蹤報表格式下載
                    </Link>
                </Grid>
            </Grid>

            {/* 刪除確認 Dialog */}
            {
                deleteConfirmOpen && (
                    <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
                        <DialogTitle>確認刪除</DialogTitle>
                        <DialogContent>
                            <Typography>確定要刪除這筆進度紀錄嗎？刪除後無法復原。</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setDeleteConfirmOpen(false)}>取消</Button>
                            <Button
                                onClick={confirmDelete}
                                style={{ backgroundColor: "#999", color: "#fff" }}
                                variant="contained"
                            >
                                確認刪除
                            </Button>
                        </DialogActions>
                    </Dialog>
                )
            }
            {/* 新增 Dialog */}
            {
                openDialog && (
                    <ProgressTrackingDialog
                        open={openDialog}
                        onClose={() => setOpenDialog(false)}
                        onSave={handleSave}
                        getColumnInfo={Actions_Wind_V2.getProgressTrackingSheetColumnInfo}
                        getLastDocument={Actions_Wind_V2.getLastProgressTrackingSheetDocument}
                        windcontract_id={Actions_Wind.wind_id()}
                    />
                )
            }
            {/* 檢視 Dialog */}
            {
                viewDialogOpen && (
                    <ProgressTrackingViewDialog
                        open={viewDialogOpen}
                        onClose={() => setViewDialogOpen(false)}
                        sheetId={selectedId}
                        getDocument={Actions_Wind_V2.getAProgressTrackingSheetDocument}
                    />
                )
            }
            {/* 編輯 Dialog */}
            {
                editDialogOpen && (
                    <ProgressTrackingEditDialog
                        open={editDialogOpen}
                        onClose={() => setEditDialogOpen(false)}
                        sheetId={selectedId}
                        onSave={handleSave}
                        getColumnInfo={Actions_Wind_V2.getProgressTrackingSheetColumnInfo}
                        getDocument={Actions_Wind_V2.getAProgressTrackingSheetDocument}
                    />
                )
            }
        </Box>
    );
}

const mapStateToProps = (state) => ({
    sign: state.data?.AtyFunction,
    ProjectProgressList: state.data?.ProjectProgressList || {},
    ...permission.returnPermission(state),
});

const mapDispatchToProps = (dispatch) => ({
    getProjectProgressList: (body) => Actions_Wind.getProjectProgressList(dispatch, body),
    deleteProjectProgress: (id) => Actions_Wind.deleteProjectProgress(dispatch, { id }),
    getProgressTrackingSheetDocuments: (body) => Actions_Wind_V2.getProgressTrackingSheetDocuments(body),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_PPTrackSheet);
